import { useCallback, useMemo, useState, useEffect } from 'react'
import TreeModel from 'tree-model-improved'
import { UserPermissions } from 'web/src/services/permissions'

export const treeNodeIdAccessor = data => String(data.id)
export const treeNodeChildrenAccessor = data =>
    Array.isArray(data?.children) && data.children.length ? data.children : null

export const isLocationSelectionDisabled = data => {
    const location = data?.location

    return Boolean(
        location?.is_customer_title ||
            location?.is_bottom_padding_node ||
            (!location?.is_assigned && !UserPermissions.isAllOriginalGranted())
    )
}

function findById(node, id) {
    return node.first(n => n.model.id === id)
}

export function useTreeUtils(initData) {
    const [data, setData] = useState(initData)
    const root = useMemo(
        () => (data?.id ? new TreeModel().parse(data) : {}),
        [data]
    )
    const find = useCallback(id => findById(root, id), [root])
    const update = () =>
        setData({
            ...root.model,
            children: [...(root.model.children || [])]
        })

    const hasChildren = root?.model?.withBottomPaddingNodes
        ? root?.children?.length > 3
        : root?.hasChildren
        ? root?.hasChildren()
        : false

    useEffect(() => {
        setData(initData)
    }, [initData])

    return {
        data,
        root,
        hasChildren: hasChildren,
        addChild: (newItem, dstParentId) => {
            const dstParent = dstParentId ? find(dstParentId) : root

            if (!newItem || !dstParent) return

            const treeitemToAdd = new TreeModel().parse(newItem)
            const itemNode = dstParent.addChild(treeitemToAdd)
            update()
            return itemNode
        },
        deleteNode: id => {
            const node = find(id)
            node.drop()
            update()
        }
    }
}
